// extracted by mini-css-extract-plugin
export default {"container":"container__wUlxY","imgBox":"imgBox__hVK0j","img":"img__S8eEs","titleContainer":"titleContainer__EbWUu","title":"title__pTz12"};